// components/TableInsertDropdown.tsx
import React, { useState } from "react";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { INSERT_TABLE_COMMAND } from "@lexical/table";
import { Popover, Box, Typography, IconButton, alpha, useTheme, } from "@mui/material";
import TableChartRoundedIcon from '@mui/icons-material/TableChartRounded';
import { $createTableNodeWithDimensions } from "@lexical/table";
import { $insertNodeToNearestRoot } from "@lexical/utils"



const MAX_ROWS = 6;
const MAX_COLS = 6;

interface TableInsertDropdownProps {
    disabled?: boolean;
}

const TableInsertDropdown = ({ disabled }: TableInsertDropdownProps) => {
    const [editor] = useLexicalComposerContext();
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
    const [hovered, setHovered] = useState<any>({ rows: 0, cols: 0 });

    const theme = useTheme();
    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
        setHovered({ rows: 0, cols: 0 });
    };

    const handleClose = () => setAnchorEl(null);

    const handleSelect = (r: number, c: number) => {
            console.log('Dispatching table command:', hovered);
            try {
                editor.dispatchCommand(INSERT_TABLE_COMMAND, {
                    rows: String(r),
                    columns: String(c),
                    includeHeaders: true,
                });
                console.log('Table command dispatched successfully');
            } catch (error) {
                console.error('Error dispatching table command:', error);
            }
      
        handleClose();
    };

    const onAddTable = (rowIdx: any, colIdx: any) => {
        editor.update(() =>  {
            const tableNode = $createTableNodeWithDimensions(rowIdx, colIdx, true);
            $insertNodeToNearestRoot(tableNode)         
        })
        // setHovered({ rows: 0, cols: 0 });
    }


    return (
        <>
            <IconButton
                size="small"
                onClick={handleClick}
                disabled={disabled}
                sx={{
                    borderRadius: 1,
                    "&:hover": { backgroundColor: alpha(theme.palette.text.primary, 0.08) },
                }}
            >
                <TableChartRoundedIcon sx={{ fontSize: 20, color: disabled ? "#E5E4E2" : "text.secondary" }} />
            </IconButton>
            <Popover
                open={open}     
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                disableRestoreFocus
                PaperProps={{ sx: { p: 1, backgroundColor: "#fff" } }}
            >
                <Box>
                    <Box sx={{ display: "grid", gridTemplateColumns: `repeat(${MAX_COLS}, 24px)`, gap: 1 }}>
                        {Array.from({ length: MAX_ROWS }).map((_, rowIdx) =>
                            Array.from({ length: MAX_COLS }).map((_, colIdx) => {
                                const isActive =
                                    rowIdx < hovered.rows && colIdx < hovered.cols;
                                return (
                                    <Box
                                        key={`${rowIdx}-${colIdx}`}
                                        onClick={() => onAddTable(rowIdx + 1, colIdx + 1)}
                                        sx={{
                                            width: 24,
                                            height: 24,
                                            border: "1px solid #ccc",
                                            backgroundColor: isActive ? "#4caf50" : "#f0f0f0",
                                            cursor: "pointer",
                                        }}
                                        onMouseEnter={() =>
                                            setHovered({ rows: rowIdx + 1, cols: colIdx + 1 })
                                        }

                                    />
                                );
                            })
                        )}
                    </Box>
                    <Typography
                        variant="caption"
                        sx={{ mt: 1, textAlign: "center", display: "block", color: "text.secondary" }}
                    >
                        {hovered.rows > 0 && hovered.cols > 0
                            ? `${hovered.rows} × ${hovered.cols}`
                            : "Select size"}
                    </Typography>
                </Box>
            </Popover>
        </>
    );
};

export default TableInsertDropdown;
